import leftCrystal from 'assets/games/theme-mrr/slot/left.png';
import rightCrystal from 'assets/games/theme-mrr/slot/right.png';
import leftGraphic from 'assets/games/theme-two/slot/winner/leftGraphic.png';
import rightGraphic from 'assets/games/theme-two/slot/winner/rightGraphic.png';
import leftBottomCrystal from 'assets/games/theme-two/slot/winner/leftBottomCrystal.png';
import rightBottomCrystal from 'assets/games/theme-two/slot/winner/rightBottomCrystal.png';

import styles from './graphic.module.css';

function Pulse() {
  return (
    <>
      <div className={styles.slotMachineBgPulse}></div>
      <div
        className={styles.slotMachineBgPulse}
        style={{ top: '50%', left: '50%', position: 'absolute' }}
      ></div>
      <div
        className={styles.slotMachineBgPulse}
        style={{ right: '0', position: 'absolute' }}
      ></div>
    </>
  );
}

function SlotMachineGraphic({ isWinner }) {
  return (
    <div className={styles.SlotMachineGraphic}>
      {/*<img*/}
      {/*  src={leftGraphic}*/}
      {/*  alt="leftGraptic"*/}
      {/*  className={`${styles.leftGraphic} */}
      {/*    ${isWinner === 1 ? 'bounceIn' : ''} */}
      {/*    ${isWinner === 0 ? 'bounceOut' : ''}`}*/}
      {/*/>*/}
      <img src={leftCrystal} alt="leftCrystal" className={styles.leftCrystal} />
      {/*<img*/}
      {/*  src={rightGraphic}*/}
      {/*  alt="rightGraptic"*/}
      {/*  className={`${styles.rightGraphic} */}
      {/*    ${isWinner === 1 ? 'bounceIn' : ''} */}
      {/*    ${isWinner === 0 ? 'bounceOut' : ''}`}*/}
      {/*/>*/}
      <img
        src={rightCrystal}
        alt="rightCrystal"
        className={styles.rightCrystal}
      />
      {/*<img*/}
      {/*  src={leftBottomCrystal}*/}
      {/*  alt="leftBottomCrystal"*/}
      {/*  className={`${styles.leftBottomCrystal} */}
      {/*    ${isWinner === 1 ? 'bounceIn' : ''} */}
      {/*    ${isWinner === 0 ? 'bounceOut' : ''}`}*/}
      {/*/>*/}
      {/*<img*/}
      {/*  src={rightBottomCrystal}*/}
      {/*  alt="rightBottomCrystal"*/}
      {/*  className={`${styles.rightBottomCrystal} */}
      {/*    ${isWinner === 1 ? 'bounceIn' : ''} */}
      {/*    ${isWinner === 0 ? 'bounceOut' : ''}`}*/}
      {/*/>*/}
    </div>
  );
}

export { SlotMachineGraphic, Pulse };
